module.exports = __webpack_public_path__ + "img/cvf-id.bd579746.png";